import {Module} from "../index";
import SettingsIndex from "./pages/Index.vue";
import SettingRepository from "@/modules/settings/services/SettingRepository";
import {Setting} from "@/modules/settings/entity";
import messages from "./resources/messages";

export class SettingsModule extends Module {
  messages = messages;

  public entities = [
    Setting,
  ];

  routes = [{
    path: '/settings',
    name: 'settings.index',
    component: SettingsIndex,
  }];

  protected register() {
    super.register();

    this.app.bind<SettingRepository>(SettingRepository).to(SettingRepository).inSingletonScope();
  }

  boot() {
    super.boot();
  }
}
